import React from "react";

export default function TermCondition() {
  return (
    <div className="py-0">
     {/* Breadcrumb */}
          <div className="text-sm text-gray-500 mb-10">
            Home <span className="mx-2">/</span>
            Our Policies <span className="mx-2">/</span>
            <span className="text-black">Terms and Conditions</span>
          </div>

      {/* Title */}
     {/* Title */}
     <div className="mb-6">
       <h1 className="text-2xl font-semibold text-left">
         Terms and Conditions
       </h1>

       {/* Line Below Title */}
       <div className="w-full h-[1px] bg-gray-300 mx-auto mt-2"></div>
     </div>



      {/* Content */}
      <div className="space-y-8 text-sm leading-7 text-gray-800">

        {/* Section */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            General Use
          </h2>
          <p>
            The Events App provides information about events including concerts,
            workshops, festivals, exhibitions, and local meetups.
          </p>
          <p>
            Users must be at least 18 years of age or have parental consent to register.
          </p>
          <p>
            By creating an account or browsing events, you agree to comply with
            local laws and our terms.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            User Accounts
          </h2>
          <p>
            Users are responsible for maintaining the confidentiality of their login credentials.
          </p>
          <p>
            Services must provide accurate, current, and complete information during registration.
          </p>
          <p>
            We reserve the right to suspend or terminate any account that violates our terms or community standards.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Event Listings
          </h2>
          <p>
            Events are categorized (e.g., Music, Business, Family, Arts, Food & Drink, Sports, etc.) and tailored to different cities.
          </p>
          <p>
            While we strive for accuracy, [App Name] does not guarantee the correctness of event details including location, timing, or pricing.
          </p>
          <p>
            Event organizers are responsible for the content they submit and must ensure it is lawful and accurate.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Tickets and Payments
          </h2>
          <p>
            Tickets may be sold through third-party services or directly through the app.
          </p>
          <p>
            All ticket sales are subject to the event organizer’s refund and cancellation policies.
          </p>
          <p>
            Happenhood is not liable for event cancellations or schedule changes unless we are the direct organizer.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Cancellations and Refunds
          </h2>
          <p>
            Refund eligibility varies by event and organizer. Please refer to each event’s specific refund policy.
          </p>
          <p>
            Happenhood may charge service or processing fees that are non-refundable.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            City-Specific Regulations
          </h2>
          <p>
            Events and user conduct must comply with local laws and municipal guidelines in each city.
          </p>
          <p>
            Certain categories may be restricted in some cities (e.g., alcohol-related events, adult content).
          </p>
          <p>
            We reserve the right to modify or restrict listings based on regional regulations.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Code of Conduct
          </h2>
          <p>
            Users must not harass, abuse, or spam others on the platform.
          </p>
          <p>
            Hate speech, illegal activity, and offensive content are strictly prohibited.
          </p>
          <p>
            We may remove or report users/events that violate these standards.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Intellectual Property
          </h2>
          <p>
            All content on the platform, including logos, text, and images, is the property of [App Name] or its licensors.
          </p>
          <p>
            You may not copy, modify, or distribute app content without prior permission.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Liability and Disclaimer
          </h2>
          <p>
            Happenhood is not responsible for the safety, quality, or execution of any listed event.
          </p>
          <p>
            Use the app at your own risk. We provide no warranties for uninterrupted or error-free service.
          </p>
          <p>
            In no event shall Happenhood be liable for indirect or consequential damages.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Modifications
          </h2>
          <p>
            We may update these Terms from time to time. Continued use of the app constitutes acceptance of any changes.
          </p>
          <p>
            Users will be notified of significant updates via email or in-app notifications.
          </p>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            Contact Us
          </h2>
          <p>
            If you have questions about these Terms or need assistance, contact us at:
          </p>
          <p className="text-blue-500">
            support@happenhood.com
          </p>
          <p>
            📍 [Happenhood, Noida, India]
          </p>
        </section>

      </div>
    </div>
  );
}